module.exports = __webpack_public_path__ + "static/media/close-img.086d796e.svg";